import { TrialPeriodAdminzoneState } from "@/types/store/adminzone/trialPeriod";
import { TrialPeriodData } from "@/types";

export const state: TrialPeriodAdminzoneState = {
  trialPeriod: [] as Array<TrialPeriodData>
}
